import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import I18n from '@app/modules/i18n/index';
import Radio from '@component/form/element/radio';

const TransferTypeSelector = ({
  type,
  onTransferTypeEmailClick,
  onTransferTypeLinkClick,
}) => (
  <>
    <div
      className={classnames('wizard__box', {
        'wizard__box--active': type === 'email',
      })}
      onClick={onTransferTypeEmailClick}
    >
      <Radio
        className="transfer__type-radio"
        name="transfer__type-email"
        label={I18n.t('transfer.mobile.options.email')}
        checked={type === 'email'}
        onChange={onTransferTypeEmailClick}
      />
      <p className="radioinput__content">
        {I18n.t('transfer.mobile.options.email-description')}
      </p>
    </div>
    <div
      className={classnames('wizard__box', {
        'wizard__box--active': type === 'link',
      })}
      onClick={onTransferTypeLinkClick}
    >
      <Radio
        className="transfer__type-radio"
        name="transfer__type-link"
        label={I18n.t('transfer.mobile.options.link')}
        checked={type === 'link'}
        onChange={onTransferTypeLinkClick}
      />
      <p className="radioinput__content">
        {I18n.t('transfer.mobile.options.link-description')}
      </p>
    </div>
  </>
);

TransferTypeSelector.propTypes = {
  type: PropTypes.string,
  onTransferTypeLinkClick: PropTypes.func.isRequired,
  onTransferTypeEmailClick: PropTypes.func.isRequired,
};

export default TransferTypeSelector;
